import React, { forwardRef } from "react";

import { concatClassNames } from "../../utils/styles";
import { SVGName } from "../Svg";
import { Clickable } from "./Clickable";
import { ConditionalIcons, IconMap } from "./ConditionalIcons";
import { ClickableProps } from "./types";

import styles from "./ButtonPrimary.module.scss";

export const icons: IconMap<SVGName> = {
    download: "download",
    external: "external",
};

export const ButtonPrimary = forwardRef<
    HTMLButtonElement | HTMLAnchorElement,
    ClickableProps
>(function ButtonPrimary({ ...props }, ref) {
    return (
        <Clickable
            {...props}
            ref={ref}
            className={concatClassNames([
                styles.primaryButton,
                props.onDark ? styles.onDark : undefined,
                props.disabled ? styles.disabled : undefined,
                props.className ?? undefined,
            ])}
        >
            {props.children}
            <ConditionalIcons {...props} mappedConditionalIcons={icons} />
        </Clickable>
    );
});
